import React from 'react';

class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'oc'
  }
  render() {
    const {
      prefixCls,
    } = this.props;

    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-con`}>
          <h2>一、创建应用</h2>
          <p>1、开发者填写应用名称、开发账号</p>
          <p>2、系统自动分配应用编码、GIT项目地址、初始项目结构，用于后续开发及代码管理</p>
          <p>备注：需要开发者权限请联系云商店admin</p>
          <br />
          <h2>二、发布应用</h2>
          <p>1、填写必要信息</p>
          <p>2、提交后云商店admin审核</p>
          <br />
          <h2>三、更新应用</h2>
          <p>1、进入【开发者】界面</p>
          <p>2、点击更新应用</p>
          <p>3、修改必要信息</p>
          <p>4、提交后云商店admin审核</p>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/oc/OcQues.js